<div class="verification-results-container">
    <!-- Content Section -->
    <div class="collapse" :class="{ 'show': active_tabs.includes('Forms') }">
      <div class="mt-2">
        <div class="border-0 p-2 rounded-lg">

          <!-- Services Content - Only shown when dropdown is open -->
          <div v-if="is_trust_form_open" class="compliance-monitoring-projects-wrapper">

            <!-- Loading State -->
            <div v-if="loading_results" class="text-center p-4">
              <div class="spinner-border spinner-border-sm" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <span class="ms-2 text-xxs">Loading verification results...</span>
            </div>

            <!-- Error State -->
            <div v-else-if="error_message" class="alert alert-danger">
              {{ error_message }}
            </div>

            <!-- Results Section -->
            <div v-else-if="verification_results.length > 0">
              <div
                class="compliance-monitoring-project-accordion border border-2 rounded-lg mb-3 shadow"
                v-for="(service, index) in verification_results"
                :key="service.id"
                v-show="should_show_service(service)"
              >
                <div class="compliance-monitoring-project-header" @click="toggle_expanded(index)">
                  <div class="compliance-monitoring-project-connector"></div>
                  <div class="d-flex align-items-center">
                    <i class="bi" :class="expanded_index === index ? 'bi-chevron-down' : 'bi-chevron-right'"></i>
                    <div class="ms-2">
                      <i class="bi" :class="get_service_icon(service.name)"></i>
                    </div>
                    <div class="ms-3">
                      <div class="d-flex align-items-center gap-2 mb-1">
                        <p class="mb-0 text-xs">{{ service.name }}</p>
                        <span class="status-badge" :class="get_overall_status_class(service)">{{ get_overall_status(service) }}</span>
                      </div>
                      <p class="mb-0 text-xxs text-muted">Last updated: {{ get_last_updated() }}</p>
                    </div>
                  </div>
                </div>

                <!-- Detail Panel -->
                <div v-if="expanded_index === index" class="p-3">
                  
                  <!-- Service Status Message -->
                  <div class="alert" :class="get_alert_class(service)" role="alert">
                    <strong>{{ service.name }} Status:</strong> {{ get_service_message(service) }}
                  </div>

                  <!-- Field Results -->
                  <div v-if="has_field_results(service)" class="mb-4">
                    <h6 class="text-xs fw-bold mb-3">Field Verification Results</h6>
                    <div class="table-responsive">
                      <table class="table table-sm table-bordered">
                        <thead>
                          <tr>
                            <th class="text-xxs">Field</th>
                            <th class="text-xxs">User Answer</th>
                            <th class="text-xxs">Verified Value</th>
                            <th class="text-xxs">Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(field, fieldName) in get_field_results(service)" :key="fieldName">
                            <td class="text-xxs">{{ formatKey(fieldName) }}</td>
                            <td class="text-xxs">{{ field.user_answer || 'N/A' }}</td>
                            <td class="text-xxs">{{ field.api_value || 'N/A' }}</td>
                            <td class="text-xxs">
                              <span class="badge" :class="field.match ? 'bg-success' : 'bg-danger'">
                                {{ field.match ? 'Match' : 'Mismatch' }}
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <!-- Detailed Results Data -->
                  <div v-if="has_detailed_results(service)" class="mb-4 ">
                    <h6 class="text-xs fw-bold mb-3">Detailed Results</h6>
                    <div class="detailed-results-container mb-4 border p-3 rounded">
                      <div v-for="(section, sectionName) in get_detailed_results(service)" :key="sectionName" 
                           class="detailed-section mb-3">
                        <h6 class="text-xs fw-bold mb-3 pb-2 border-bottom">{{ formatKey(sectionName) }}</h6>
                        
                        <div v-if="Array.isArray(section) && section.length > 0" class="array-data">
                          <div v-for="(item, idx) in section" :key="idx" class="mb-3 pb-3 border-bottom">
                            <p class="text-xxs text-muted mb-2"><strong>Entry {{ idx + 1 }}</strong></p>
                            <div class="row g-2">
                              <div class="col-12" v-for="(value, key) in item" :key="key">
                                <div class="d-flex justify-content-between align-items-center py-1">
                                  <span class="text-xxs text-muted">{{ formatKey(key) }}:</span>
                                  <span class="text-xxs text-end ms-3">{{ formatValue(value) }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        
                        <div v-else-if="isNestedObject(section)" class="nested-data">
                          <div class="row g-2">
                            <div class="col-12" v-for="(value, key) in section" :key="key">
                              <div class="d-flex justify-content-between align-items-center py-1 border-bottom">
                                <span class="text-xxs text-muted">{{ formatKey(key) }}:</span>
                                <span class="text-xxs text-end ms-3">{{ formatValue(value) }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        
                        <div v-else class="text-xxs">
                          {{ formatValue(section) }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Empty Results Message -->
                  <div v-if="!has_field_results(service) && !has_detailed_results(service)" class="text-center p-3">
                    <i class="bi bi-info-circle fs-4 text-muted"></i>
                    <p class="text-muted mt-2 mb-0 text-xs">No detailed results available for this service.</p>
                  </div>
                </div>
              </div>
            </div>

            <!-- Empty State -->
            <div v-else class="text-center p-4 border rounded-lg mt-3 shadow">
              <i class="bi bi-inbox fs-1 text-muted"></i>
              <p class="text-muted mt-2 mb-0 text-xs">No verification results found.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>